import { render, staticRenderFns } from "./JdsPaginator.vue?vue&type=template&id=d0ca66ca&scoped=true&"
import script from "./JdsPaginator.vue?vue&type=script&lang=ts&"
export * from "./JdsPaginator.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPaginator.vue?vue&type=style&index=0&id=d0ca66ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ca66ca",
  null
  
)

export default component.exports